export const AppRoles = [
  "Super_Admin",
  "District_Admin",
  "Parent",
  "Teacher",
  "Student",
  "Attendance_coordinator",
  "Clerk",
];

export const IS_Status = {
  IS_Requested: "IS Requested",
};
export const getStatusesData = (duration?: number) => {
  const statusesData: Record<
    string,
    {
      title: string;
      description: string;
      color: string;
      duration?: string;
      waitingTitle?: string;
      waitingDescription?: string;
    }
  > = {
    ...(duration && duration >= 10
      ? {
          Principal_Approval: {
            title: "IS Requested",
            description: "A new IS request has been submitted.",
            color: "#fbbf24", // yellow
            waitingTitle: "Waiting for Principal Approval",
            waitingDescription: "Pending principal's review of the IS request.",
          },
          LEA_Approval: {
            title: "Principal Approved",
            description: "Principal has approved the IS request.",
            color: "#10b981", // green
            waitingTitle: "Waiting for Principal Approval",
            waitingDescription: "Pending principal approval of the IS request.",
          },
        }
      : {}),

    ...(duration && duration >= 10
      ? {
          IS_Requested: {
            title: "LEA Approved",
            description: "LEA has approved the IS request.",
            color: "#3b82f6", // blue
            waitingTitle: "Waiting for LEA Approval",
            waitingDescription: "Pending LEA approval of the IS request.",
          },
        }
      : {
          IS_Requested: {
            title: "IS Requested",
            description: "A new IS request has been submitted.",
            color: "#fbbf24", // yellow
            waitingTitle: "Waiting for Request Processing",
            waitingDescription: "IS request is being processed.",
          },
        }),
    StudentReview: {
      title: "IS Assigned",
      description: "Objectives have been assigned.",
      color: "#14b8a6", // teal
      waitingTitle: "Waiting for Assignment",
      waitingDescription: "Pending assignment of objectives to student.",
    },
    UnderReview: {
      title: "IS Under Review",
      description: "Student has completed the given objectives.",
      color: "#f59e0b", // amber
      waitingTitle: "Waiting for Student Completion",
      waitingDescription: "Pending student completion of assigned objectives.",
    },
    AttendanceCoordinatorReview: {
      title: "IS Completed",
      description: "Teacher has reviewed the completion of the study plan.",
      color: "#3b82f6", // blue
      waitingTitle: "Waiting for Teacher Review",
      waitingDescription: "Pending teacher review of student's completed work.",
    },
    LEAReview: {
      title: "IS Verified",
      description: "Attendance Coordinator has verified the completion.",
      color: "#8b5cf6", // purple
      waitingTitle: "Waiting for ATC Verification",
      waitingDescription: "Pending Attendance Coordinator verification.",
    },
    Completed: {
      title: "ADA Completed",
      description: "ADA recovered successfully.",
      color: "#22c55e", // green
      waitingTitle: "Waiting for ADA Completion",
      waitingDescription: "Pending final ADA completion.",
    },
  };
  return statusesData;
};
